(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.updateHeaderHeight();

      window.addEventListener('resizeend', () => {
        requestAnimationFrame(() => this.updateHeaderHeight());
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    updateHeaderHeight() {
      const headerBar = this.header.querySelector('.header') || this.header;
      const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
      const height = isVisible ? headerBar.offsetHeight : 0;
      this.headerHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--header-height-live', `${height}px`);
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-support-hub"] && !Shopify.designMode) return;
  try {
    
  class ProductSupportHub {
    constructor(root) {
      this.root = root;
      this.sectionScope = root.closest('.shopify-section') || root;
      this.grid = root.querySelector('[data-psh-grid]');
      this.cards = this.grid ? Array.from(this.grid.querySelectorAll('[data-psh-card]')) : [];
      this.searchInput = root.querySelector('[data-psh-search]');
      this.categorySearchInput = root.querySelector('[data-psh-category-search]');
      this.categoryFilters = Array.from(root.querySelectorAll('[data-psh-category-filter]'));
      this.typeFilters = Array.from(root.querySelectorAll('[data-psh-type-filter]'));
      this.sortSelect = root.querySelector('[data-psh-sort]');
      this.resultCount = root.querySelector('[data-psh-result-count]');
      this.emptyFiltered = root.querySelector('[data-psh-empty-filtered]');
      this.loadMoreButton = root.querySelector('[data-psh-load-more]');
      this.modal = this.sectionScope.querySelector('[data-psh-modal]');
      this.requestModal = this.sectionScope.querySelector('[data-psh-request-modal]');
      this.filterDrawer = this.sectionScope.querySelector('[data-psh-filter-drawer]');
      this.filterDrawerContent = this.sectionScope.querySelector('[data-psh-filter-drawer-content]');
      this.filterOpenButton = root.querySelector('[data-psh-filter-open]');
      this.filterApplyButton = this.sectionScope.querySelector('[data-psh-filter-apply]');
      this.sidebar = root.querySelector('[data-psh-sidebar]');
      this.sidebarSlot = root.querySelector('[data-psh-sidebar-slot]');
      this.controlsRow = root.querySelector('[data-psh-controls-row]');
      this.main = root.querySelector('.product-support-hub__main');
      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.config = this.readConfig();
      this.visibleLimit = this.getProductsPerPage();
      this.filteredCards = [...this.cards];
      this.bindEvents();
      this.setupMobileLayout();
      this.bootstrap();
    }

    getProductsPerPage() {
      const fromRoot = Number.parseInt(this.root.dataset.pshProductsPerPage, 10);
      if (Number.isFinite(fromRoot) && fromRoot > 0) return fromRoot;

      const fromConfig = Number.parseInt(this.config?.productsPerPage, 10);
      if (Number.isFinite(fromConfig) && fromConfig > 0) return fromConfig;

      return 9;
    }

    readConfig() {
      const configNode = this.sectionScope.querySelector('[data-psh-config]');
      if (!configNode) return {};
      try {
        return JSON.parse(configNode.textContent.trim());
      } catch (error) {
        return {};
      }
    }

    parseFilterCategories(raw, fallbackCategory) {
      const keys = (raw || '')
        .split('##')
        .map((key) => key.trim())
        .filter(Boolean);

      if (keys.length === 0) {
        const fallback = (fallbackCategory || '').trim();
        if (fallback) keys.push(fallback);
      }

      return keys;
    }

    async bootstrap() {
      await this.loadAdditionalProductPages();
      this.applyFilters(false);
    }

    async loadAdditionalProductPages() {
      const total = Number(this.config.totalCollectionCount || 0);
      const pageSize = Number(this.config.paginateSize || 250);
      const totalPages = Math.ceil(total / pageSize);

      if (!this.grid || totalPages <= 1 || !this.config.sectionId) return;

      for (let page = 2; page <= totalPages; page += 1) {
        const url = `${window.location.pathname}?sections=${encodeURIComponent(this.config.sectionId)}&page=${page}`;

        try {
          const response = await fetch(url);
          if (!response.ok) continue;

          const data = await response.json();
          const html = data[this.config.sectionId];
          if (!html) continue;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('[data-psh-grid]');
          if (!newGrid) continue;

          newGrid.querySelectorAll('[data-psh-card]').forEach((card) => {
            const importedCard = document.importNode(card, true);
            this.grid.appendChild(importedCard);
            this.mergeCategoriesFromCard(importedCard);
          });
        } catch (error) {
          continue;
        }
      }

      this.cards = Array.from(this.grid.querySelectorAll('[data-psh-card]'));
      this.recalculateCategoryCounts();
    }

    mergeCategoriesFromCard(card) {
      const categoryList = this.root.querySelector('[data-psh-category-list]');
      if (!categoryList) return;

      const filterKeys = this.parseFilterCategories(
        card.dataset.filterCategories,
        card.dataset.category
      );

      filterKeys.forEach((label) => {
        if (this.categoryFilters.some((input) => input.value === label)) return;

        this.categoryFilterIndex = (this.categoryFilterIndex || this.categoryFilters.length) + 1;
        const itemId = `ProductSupportCategory-${this.config.sectionId}-${this.categoryFilterIndex}`;

        const item = document.createElement('li');
        item.className = 'product-support-hub__filter-item facets__item';
        item.setAttribute('data-psh-category-item', '');
        item.dataset.categoryLabel = label;
        item.dataset.pshCategoryWithCount = '0';
        item.dataset.pshCategoryMissingCount = '0';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'field__checkbox';
        input.id = itemId;
        input.value = label;
        input.setAttribute('data-psh-category-filter', '');
        input.checked = true;

        const labelEl = document.createElement('label');
        labelEl.className = 'facets__label facet-checkbox';
        labelEl.htmlFor = itemId;
        labelEl.innerHTML = `
          <span class="facet-checkbox__text">
            <span class="facet-checkbox__text-label">${this.escapeHtml(label)}</span>
            <span class="facet__results">(0)</span>
          </span>
        `;

        item.appendChild(input);
        item.appendChild(labelEl);
        categoryList.appendChild(item);

        input.addEventListener('change', () => this.applyFilters(true));
        this.categoryFilters.push(input);
      });
    }

    recalculateCategoryCounts() {
      const tallies = new Map();

      this.cards.forEach((card) => {
        const hasResources = card.dataset.hasResources !== 'false';
        const keys = this.parseFilterCategories(
          card.dataset.filterCategories,
          card.dataset.category
        );

        keys.forEach((label) => {
          if (!tallies.has(label)) tallies.set(label, { with: 0, missing: 0 });
          const tally = tallies.get(label);
          if (hasResources) tally.with += 1;
          else tally.missing += 1;
        });
      });

      this.categoryFilters.forEach((input) => {
        const item = input.closest('[data-psh-category-item]');
        if (!item) return;

        const tally = tallies.get(input.value) || { with: 0, missing: 0 };
        item.dataset.pshCategoryWithCount = String(tally.with);
        item.dataset.pshCategoryMissingCount = String(tally.missing);

        const countEl = item.querySelector('.facet__results');
        if (countEl) countEl.textContent = `(${tally.with})`;
      });
    }

    bindEvents() {
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.applyFilters(true));
      }

      if (this.categorySearchInput) {
        this.categorySearchInput.addEventListener('input', () => this.filterCategoryList());
      }

      this.sectionScope.addEventListener('click', (event) => {
        if (event.target.closest('[data-psh-category-select-all]')) {
          event.preventDefault();
          this.setCategoryChecks(true);
          return;
        }

        if (event.target.closest('[data-psh-category-deselect-all]')) {
          event.preventDefault();
          this.setCategoryChecks(false);
          return;
        }
      });

      this.categoryFilters.forEach((input) => {
        input.addEventListener('change', () => this.applyFilters(true));
      });

      this.typeFilters.forEach((input) => {
        input.addEventListener('change', () => this.applyFilters(true));
      });

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.applyFilters(true));
      }

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => {
          this.visibleLimit += this.getProductsPerPage();
          this.renderCards();
        });
      }

      this.sectionScope.addEventListener('click', (event) => {
        const openTrigger = event.target.closest('[data-psh-open]');
        if (openTrigger) {
          event.preventDefault();
          event.stopPropagation();
          const card = openTrigger.closest('[data-psh-card]');
          if (card) this.openModal(card);
          return;
        }

        const requestTrigger = event.target.closest('[data-psh-request]');
        if (requestTrigger) {
          event.preventDefault();
          event.stopPropagation();
          const card = requestTrigger.closest('[data-psh-card]');
          if (card) this.openRequestModal(card);
          return;
        }

        if (event.target.closest('[data-psh-close]')) {
          event.preventDefault();
          this.closeModal();
        }

        if (event.target.closest('[data-psh-request-close]')) {
          event.preventDefault();
          this.closeRequestModal();
        }

        if (event.target.closest('[data-psh-filter-open]')) {
          event.preventDefault();
          this.openFilterDrawer();
          return;
        }

        if (event.target.closest('[data-psh-filter-close]')) {
          event.preventDefault();
          this.closeFilterDrawer();
          return;
        }

        if (event.target.closest('[data-psh-filter-apply]')) {
          event.preventDefault();
          this.closeFilterDrawer();
        }
      });

      if (this.modal) {
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) {
            this.closeModal();
            return;
          }

          const facade = event.target.closest('.iag-install-video-facade[role="button"]');
          if (facade) {
            event.preventDefault();
            this.loadInstallVideo(facade);
            return;
          }

          const tab = event.target.closest('.iag-install-video-tabs__tab');
          if (tab) {
            event.preventDefault();
            this.activateVideoTab(tab);
          }
        });

        this.modal.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;

          const facade = event.target.closest('.iag-install-video-facade[role="button"]');
          if (facade) {
            event.preventDefault();
            this.loadInstallVideo(facade);
            return;
          }

          const tab = event.target.closest('.iag-install-video-tabs__tab');
          if (tab) {
            event.preventDefault();
            this.activateVideoTab(tab);
          }
        });

        this.modal.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeModal();
        });
      }

      if (this.requestModal) {
        this.requestModal.addEventListener('click', (event) => {
          if (event.target === this.requestModal) this.closeRequestModal();
        });

        this.requestModal.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeRequestModal();
        });
      }

      if (this.mobileMediaQuery) {
        this.mobileMediaQuery.addEventListener('change', () => this.setupMobileLayout());
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.filterDrawer?.classList.contains('psh-filter-drawer--open')) {
          this.closeFilterDrawer();
        }
      });
    }

    setupMobileLayout() {
      if (!this.sidebar || !this.filterDrawerContent || !this.sidebarSlot || !this.main) return;

      const isMobile = this.mobileMediaQuery?.matches;

      if (isMobile) {
        if (this.controlsRow && this.controlsRow.parentElement !== this.filterDrawerContent) {
          this.filterDrawerContent.appendChild(this.controlsRow);
        }

        if (this.sidebar.parentElement !== this.filterDrawerContent) {
          this.filterDrawerContent.appendChild(this.sidebar);
        }
      } else {
        this.closeFilterDrawer();

        if (this.sidebar.parentElement !== this.sidebarSlot) {
          this.sidebarSlot.appendChild(this.sidebar);
        }

        if (this.controlsRow && this.controlsRow.parentElement !== this.main) {
          this.main.insertBefore(this.controlsRow, this.main.firstChild);
        }
      }
    }

    openFilterDrawer() {
      if (!this.filterDrawer || !this.mobileMediaQuery?.matches) return;

      this.filterDrawer.hidden = false;
      this.filterDrawer.classList.add('psh-filter-drawer--open');

      if (this.filterOpenButton) {
        this.filterOpenButton.setAttribute('aria-expanded', 'true');
      }

      document.body.classList.add('overflow-hidden');
      this.updateFilterApplyButton();
    }

    closeFilterDrawer() {
      if (!this.filterDrawer) return;

      this.filterDrawer.classList.remove('psh-filter-drawer--open');
      this.filterDrawer.hidden = true;

      if (this.filterOpenButton) {
        this.filterOpenButton.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('overflow-hidden');
    }

    updateFilterApplyButton() {
      if (!this.filterApplyButton) return;

      const count = this.filteredCards.length;
      const template =
        count === 1 ? this.config.filterApplyOneTemplate : this.config.filterApplyTemplate;
      this.filterApplyButton.textContent = (template || `View ${count} results`).replace(
        '__COUNT__',
        String(count)
      );
    }

    filterCategoryList() {
      const query = (this.categorySearchInput?.value || '').trim().toLowerCase();
      this.root.querySelectorAll('[data-psh-category-item]').forEach((item) => {
        const label = (item.dataset.categoryLabel || '').toLowerCase();
        item.hidden = query !== '' && !label.includes(query);
      });
    }

    getSelectedCategories() {
      return this.categoryFilters.filter((input) => input.checked).map((input) => input.value);
    }

    getVisibleCategoryFilters() {
      return this.categoryFilters.filter((input) => {
        const item = input.closest('[data-psh-category-item]');
        return item && !item.hidden;
      });
    }

    setCategoryChecks(checked) {
      this.getVisibleCategoryFilters().forEach((input) => {
        input.checked = checked;
      });
      this.applyFilters(true);
    }

    getTypeFilters() {
      return {
        pdf: this.typeFilters.some((input) => input.dataset.pshTypeFilter === 'pdf' && input.checked),
        video: this.typeFilters.some((input) => input.dataset.pshTypeFilter === 'video' && input.checked),
        none: this.typeFilters.some((input) => input.dataset.pshTypeFilter === 'none' && input.checked)
      };
    }

    applyFilters(resetLimit) {
      if (resetLimit) this.visibleLimit = this.getProductsPerPage();

      const query = (this.searchInput?.value || '').trim().toLowerCase();
      const selectedCategories = this.getSelectedCategories();
      const typeFilters = this.getTypeFilters();
      const missingOnly = typeFilters.none && !typeFilters.pdf && !typeFilters.video;
      const isSearching = query.length > 0;

      this.filteredCards = this.cards.filter((card) => {
        const title = (card.dataset.title || '').toLowerCase();
        const category = (card.dataset.category || '').trim();
        const filterCategories = this.parseFilterCategories(
          card.dataset.filterCategories,
          category
        );
        const skus = (card.dataset.skus || '')
          .split('##')
          .filter(Boolean)
          .map((sku) => sku.toLowerCase());
        const pdfCount = Number(card.dataset.pdfCount || 0);
        const videoCount = Number(card.dataset.videoCount || 0);
        const hasResources = card.dataset.hasResources !== 'false';

        const hasCategoryFilters = this.categoryFilters.length > 0;
        const matchesCategory = !hasCategoryFilters
          ? true
          : selectedCategories.length > 0 &&
            selectedCategories.some((selected) => filterCategories.includes(selected));

        if (missingOnly) {
          if (hasResources || !matchesCategory) return false;
          return true;
        }

        if (isSearching) {
          const matchesTitle = title.includes(query);
          const matchesDisplayCategory = category.toLowerCase().includes(query);
          const matchesFilterCategory = filterCategories.some((label) => label.toLowerCase().includes(query));
          const matchesSku = skus.some((sku) => sku.includes(query));
          if (!matchesTitle && !matchesDisplayCategory && !matchesFilterCategory && !matchesSku) return false;
        }

        if (!hasResources) {
          if (!isSearching) return false;
          if (!matchesCategory) return false;
          return true;
        }

        if (!matchesCategory) return false;

        if (!typeFilters.pdf && !typeFilters.video) return false;
        if (typeFilters.pdf && typeFilters.video && pdfCount === 0 && videoCount === 0) return false;
        if (typeFilters.pdf && !typeFilters.video && pdfCount === 0) return false;
        if (!typeFilters.pdf && typeFilters.video && videoCount === 0) return false;

        return true;
      });

      this.lastFilterState = {
        query,
        selectedCategories,
        typeFilters,
        missingOnly,
        isSearching,
        resultCount: this.filteredCards.length
      };

      this.sortCards();
      this.renderCards();
    }

    getEmptyMessage() {
      const state = this.lastFilterState || {};
      const { query, selectedCategories, typeFilters, missingOnly, isSearching } = state;

      if (this.categoryFilters.length > 0 && (selectedCategories?.length || 0) === 0) {
        return this.config.emptyNoCategories || this.config.emptyFiltered;
      }

      if (!typeFilters?.pdf && !typeFilters?.video && !typeFilters?.none) {
        return this.config.emptyNoResourceTypes || this.config.emptyFiltered;
      }

      if (!missingOnly && !typeFilters?.pdf && !typeFilters?.video && typeFilters?.none) {
        return this.config.emptyNoResourceTypes || this.config.emptyFiltered;
      }

      if (isSearching && query) {
        return this.config.emptySearch || this.config.emptyFiltered;
      }

      if (!missingOnly && selectedCategories?.length) {
        let withTotal = 0;
        let missingTotal = 0;

        selectedCategories.forEach((category) => {
          this.root.querySelectorAll('[data-psh-category-item]').forEach((item) => {
            const input = item.querySelector('[data-psh-category-filter]');
            if (input?.value !== category) return;
            withTotal += Number(item.dataset.pshCategoryWithCount || 0);
            missingTotal += Number(item.dataset.pshCategoryMissingCount || 0);
          });
        });

        if (withTotal === 0 && missingTotal > 0) {
          return this.config.emptyMissingHint || this.config.emptyFiltered;
        }
      }

      return this.config.emptyFiltered;
    }

    sortCards() {
      const sortValue = this.sortSelect?.value || 'name-asc';

      this.filteredCards.sort((a, b) => {
        const titleA = (a.dataset.title || '').toLowerCase();
        const titleB = (b.dataset.title || '').toLowerCase();
        const categoryA = (a.dataset.category || '').toLowerCase();
        const categoryB = (b.dataset.category || '').toLowerCase();

        if (sortValue === 'name-desc') return titleB.localeCompare(titleA);
        if (sortValue === 'category-asc') {
          const categoryCompare = categoryA.localeCompare(categoryB);
          return categoryCompare !== 0 ? categoryCompare : titleA.localeCompare(titleB);
        }

        return titleA.localeCompare(titleB);
      });
    }

    renderCards() {
      if (!this.grid) return;

      this.cards.forEach((card) => {
        card.hidden = true;
        this.grid.appendChild(card);
      });

      const visibleCards = this.filteredCards.slice(0, this.visibleLimit);
      visibleCards.forEach((card) => {
        card.hidden = false;
        this.grid.appendChild(card);
      });

      const count = this.filteredCards.length;
      if (this.resultCount) {
        const template = count === 1 ? this.config.resultsOneTemplate : this.config.resultsTemplate;
        this.resultCount.textContent = (template || `${count} results`).replace('__COUNT__', String(count));
      }

      if (this.emptyFiltered) {
        this.emptyFiltered.hidden = count !== 0;
        if (count === 0) {
          this.emptyFiltered.textContent = this.getEmptyMessage();
        }
      }

      if (this.loadMoreButton) {
        this.loadMoreButton.hidden = this.visibleLimit >= count;
      }

      this.updateFilterApplyButton();
    }

    openModal(card) {
      if (!this.modal) return;

      this.closeRequestModal();

      const resourcesNode = card.querySelector('[data-psh-resources-json]');
      let resources = [];

      try {
        resources = JSON.parse(resourcesNode?.textContent || '[]');
      } catch (error) {
        resources = [];
      }

      const pdfs = this.normalizeResources(resources, 'pdf');
      const videos = this.normalizeResources(resources, 'video').filter((video) => video.videoId);

      const titleEl = this.modal.querySelector('[data-psh-modal-title]');
      const categoryEl = this.modal.querySelector('[data-psh-modal-category]');
      const resourcesContainer = this.modal.querySelector('[data-psh-modal-resources]');
      const emptyState = this.modal.querySelector('[data-psh-modal-empty]');
      const productLink = this.modal.querySelector('[data-psh-modal-product-link]');

      if (!titleEl || !resourcesContainer) return;

      titleEl.textContent = card.dataset.title || '';
      if (categoryEl) categoryEl.textContent = card.dataset.category || '';

      resourcesContainer.innerHTML = '';
      resourcesContainer.hidden = pdfs.length === 0 && videos.length === 0;

      if (pdfs.length > 0) {
        resourcesContainer.appendChild(this.buildPdfSection(pdfs));
      }

      if (videos.length > 0) {
        resourcesContainer.appendChild(this.buildVideoSection(videos));
      }

      if (emptyState) emptyState.hidden = pdfs.length > 0 || videos.length > 0;

      if (productLink) {
        productLink.href = card.dataset.productUrl || '#';
      }

      if (typeof this.modal.showModal === 'function') {
        try {
          this.modal.showModal();
        } catch (error) {
          this.modal.setAttribute('open', '');
          this.modal.classList.add('psh-modal--open');
        }
      } else {
        this.modal.setAttribute('open', '');
        this.modal.classList.add('psh-modal--open');
      }

      document.body.classList.add('overflow-hidden');
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    buildPdfSection(pdfs) {
      const section = document.createElement('div');
      section.className = 'iag-install-section';

      const label = document.createElement('p');
      label.className = 'iag-install-section__label';
      label.textContent = this.config.pdfsHeading || 'PDF Guides';
      section.appendChild(label);

      const list = document.createElement('ul');
      list.className = 'iag-install-pdf-list';
      list.setAttribute('role', 'list');

      pdfs.forEach((pdf) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'iag-install-pdf-row';
        link.href = pdf.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.setAttribute('download', '');
        link.setAttribute('aria-label', `Download ${pdf.title}`);

        link.innerHTML = `
          <span class="iag-install-pdf-row__icon" aria-hidden="true">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </span>
          <span class="iag-install-pdf-row__title">${this.escapeHtml(pdf.title)}</span>
          <span class="iag-install-pdf-row__arrow" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
          </span>
        `;

        li.appendChild(link);
        list.appendChild(li);
      });

      section.appendChild(list);
      return section;
    }

    buildVideoSection(videos) {
      const section = document.createElement('div');
      section.className = 'iag-install-section';

      const label = document.createElement('p');
      label.className = 'iag-install-section__label';
      label.textContent = this.config.videosHeading || 'Installation Videos';
      section.appendChild(label);

      if (videos.length === 1) {
        const wrap = document.createElement('div');
        wrap.className = 'iag-install-video-wrap';
        wrap.appendChild(this.buildVideoFacade(videos[0]));
        section.appendChild(wrap);
        return section;
      }

      const tabs = document.createElement('div');
      tabs.className = 'iag-install-video-tabs';
      tabs.setAttribute('data-video-tabs', '');

      const nav = document.createElement('div');
      nav.className = 'iag-install-video-tabs__nav';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', 'Installation videos');

      videos.forEach((video, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = `iag-install-video-tabs__tab${index === 0 ? ' is-active' : ''}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        tab.dataset.videoId = video.videoId;
        tab.dataset.videoTitle = video.title;
        tab.textContent = video.title;
        nav.appendChild(tab);
      });

      const wrap = document.createElement('div');
      wrap.className = 'iag-install-video-wrap';
      wrap.appendChild(this.buildVideoFacade(videos[0]));

      tabs.appendChild(nav);
      tabs.appendChild(wrap);
      section.appendChild(tabs);
      return section;
    }

    buildVideoFacadeMarkup(videoId, videoTitle) {
      const safeTitle = this.escapeHtml(videoTitle);
      return `
        <img
          class="iag-install-video-facade__thumb"
          src="https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg"
          alt="${safeTitle}"
          width="1280"
          height="720"
          loading="lazy"
        >
        <span class="iag-install-video-facade__play" aria-hidden="true">
          <svg viewBox="0 0 68 48" width="68" height="48" aria-hidden="true" class="iag-play-icon">
            <path class="iag-play-icon__bg" d="M66.52 7.74C65.66 4.42 63.08 1.84 59.76.98 54.52-.06 34 0 34 0S13.48-.06 8.24.98C4.92 1.84 2.34 4.42 1.48 7.74.44 13 .44 24 .44 24s0 11 1.04 16.26c.86 3.32 3.44 5.9 6.76 6.76C13.48 48.06 34 48 34 48s20.52.06 25.76-.98c3.32-.86 5.9-3.44 6.76-6.76C67.56 35 67.56 24 67.56 24s0-11-1.04-16.26z"/>
            <polygon class="iag-play-icon__arrow" points="27,17 27 31 45,24"/>
          </svg>
        </span>
        <span class="iag-install-video-facade__title">${safeTitle}</span>
      `;
    }

    buildVideoFacade(video) {
      const facade = document.createElement('div');
      facade.className = 'iag-install-video-facade';
      facade.setAttribute('role', 'button');
      facade.setAttribute('tabindex', '0');
      facade.dataset.videoId = video.videoId;
      facade.dataset.videoTitle = video.title;
      facade.setAttribute('aria-label', `Play ${video.title}`);
      facade.innerHTML = this.buildVideoFacadeMarkup(video.videoId, video.title);

      return facade;
    }

    loadInstallVideo(facade) {
      const videoId = facade.dataset.videoId;
      const videoTitle = facade.dataset.videoTitle || '';
      if (!videoId) return;

      facade.style.cursor = 'default';
      facade.removeAttribute('role');
      facade.removeAttribute('tabindex');

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1`;
      iframe.title = videoTitle;
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'eager';
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';

      facade.innerHTML = '';
      facade.appendChild(iframe);
    }

    activateVideoTab(tabEl) {
      const tabsWrapper = tabEl.closest('[data-video-tabs]');
      if (!tabsWrapper) return;

      const videoId = tabEl.dataset.videoId || '';
      const videoTitle = tabEl.dataset.videoTitle || '';

      tabsWrapper.querySelectorAll('.iag-install-video-tabs__tab').forEach((tab) => {
        tab.classList.toggle('is-active', tab === tabEl);
        tab.setAttribute('aria-selected', tab === tabEl ? 'true' : 'false');
      });

      const facade = tabsWrapper.querySelector('.iag-install-video-facade');
      if (!facade) return;

      facade.dataset.videoId = videoId;
      facade.dataset.videoTitle = videoTitle;
      facade.setAttribute('role', 'button');
      facade.setAttribute('tabindex', '0');
      facade.setAttribute('aria-label', `Play ${videoTitle}`);
      facade.style.cursor = 'pointer';
      facade.innerHTML = this.buildVideoFacadeMarkup(videoId, videoTitle);
    }

    extractVideoId(entry) {
      if (entry?.videoId) return entry.videoId;

      const url = entry?.url || '';
      const match = url.match(/(?:youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/)|youtu\.be\/)([^&?/]+)/);
      return match ? match[1] : '';
    }

    normalizeResources(resources, type) {
      const items = [];

      const addItem = (entry) => {
        const item = this.toResourceLink(entry, type);
        if (item) items.push(item);
      };

      if (Array.isArray(resources)) {
        resources.forEach((entry) => {
          if ((entry?.type || '').toLowerCase() === type) addItem(entry);
        });
        return items;
      }

      if (Array.isArray(resources[`${type}s`])) {
        resources[`${type}s`].forEach(addItem);
      }

      if (Array.isArray(resources.resources)) {
        resources.resources.forEach((entry) => {
          if ((entry?.type || '').toLowerCase() === type) addItem(entry);
        });
      }

      return items;
    }

    toResourceLink(entry, type) {
      if (!entry) return null;

      if (type === 'video') {
        const videoId = this.extractVideoId(entry);
        const url = entry.url || (videoId ? `https://www.youtube.com/watch?v=${videoId}` : '');
        if (!videoId && !url) return null;
        return { title: entry.title || 'Video', url, videoId };
      }

      if (!entry.url) return null;
      return { title: entry.title || entry.url, url: entry.url };
    }

    resetModalResources() {
      if (!this.modal) return;

      const resourcesContainer = this.modal.querySelector('[data-psh-modal-resources]');
      if (!resourcesContainer) return;

      resourcesContainer.querySelectorAll('iframe').forEach((iframe) => {
        iframe.src = '';
        iframe.remove();
      });

      resourcesContainer.innerHTML = '';
      resourcesContainer.hidden = true;
    }

    closeModal() {
      if (!this.modal) return;

      this.resetModalResources();

      if (this.modal.open) {
        this.modal.close();
      }

      this.modal.removeAttribute('open');
      this.modal.classList.remove('psh-modal--open');
      document.body.classList.remove('overflow-hidden');
    }

    openRequestModal(card) {
      if (!this.requestModal) return;

      this.closeModal();

      const title = card.dataset.title || '';
      const category = card.dataset.category || '';
      const productUrl = card.dataset.productUrl || '';
      const productId = card.dataset.productId || '';
      const primarySku = card.dataset.primarySku || '';
      const skus = (card.dataset.skus || '').split('##').filter(Boolean);
      const skuValue = primarySku || skus[0] || '';

      const categoryEl = this.requestModal.querySelector('[data-psh-request-modal-category]');
      const productEl = this.requestModal.querySelector('[data-psh-request-modal-product]');
      const titleField = this.requestModal.querySelector('[data-psh-request-field="title"]');
      const urlField = this.requestModal.querySelector('[data-psh-request-field="url"]');
      const skuField = this.requestModal.querySelector('[data-psh-request-field="sku"]');
      const productIdField = this.requestModal.querySelector('[data-psh-request-field="product-id"]');
      const bodyField = this.requestModal.querySelector('[data-psh-request-field="body"]');

      if (categoryEl) categoryEl.textContent = category;
      if (productEl) productEl.textContent = title;
      if (titleField) titleField.value = title;
      if (urlField) urlField.value = productUrl.startsWith('http') ? productUrl : `${window.location.origin}${productUrl}`;
      if (skuField) skuField.value = skuValue;
      if (productIdField) productIdField.value = productId;
      if (bodyField && !bodyField.value.trim()) {
        bodyField.value = this.config.requestMessageTemplate?.replace('__PRODUCT__', title) || '';
      }

      if (typeof this.requestModal.showModal === 'function') {
        try {
          this.requestModal.showModal();
        } catch (error) {
          this.requestModal.setAttribute('open', '');
          this.requestModal.classList.add('psh-modal--open');
        }
      } else {
        this.requestModal.setAttribute('open', '');
        this.requestModal.classList.add('psh-modal--open');
      }

      document.body.classList.add('overflow-hidden');
    }

    closeRequestModal() {
      if (!this.requestModal) return;

      if (this.requestModal.open) {
        this.requestModal.close();
      }

      this.requestModal.removeAttribute('open');
      this.requestModal.classList.remove('psh-modal--open');
      document.body.classList.remove('overflow-hidden');
    }
  }

  const initProductSupportHub = (root) => {
    if (!root || root.dataset.pshInitialized === 'true') return;
    root.dataset.pshInitialized = 'true';
    new ProductSupportHub(root);
  };

  const resetProductSupportHubs = (scope = document) => {
    scope.querySelectorAll('.product-support-hub').forEach((root) => {
      root.removeAttribute('data-psh-initialized');
    });
  };

  const initProductSupportHubs = (scope = document) => {
    scope.querySelectorAll('.product-support-hub').forEach(initProductSupportHub);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductSupportHubs());
  } else {
    initProductSupportHubs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    resetProductSupportHubs(event.target);
    initProductSupportHubs(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-menu-index"] && !Shopify.designMode) return;
  try {
    
  class VehicleMenuIndex {
    constructor(root) {
      this.root = root;
      this.searchInput = root.querySelector('[data-vehicle-menu-search]');
      this.groups = Array.from(root.querySelectorAll('[data-vehicle-menu-group]'));
      this.items = Array.from(root.querySelectorAll('[data-vehicle-menu-item]'));
      this.resultCount = root.querySelector('[data-vehicle-menu-result-count]');
      this.emptyState = root.querySelector('[data-vehicle-menu-empty]');
      this.bindEvents();
      this.updateResultCount();
    }

    bindEvents() {
      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.applySearch());
      }
    }

    applySearch() {
      const query = (this.searchInput?.value || '').trim().toLowerCase();
      let visibleGroups = 0;

      this.groups.forEach((group) => {
        const groupText = group.dataset.searchText || '';
        const modelItems = Array.from(group.querySelectorAll('[data-vehicle-menu-item]'));
        let groupHasMatch = query === '' || groupText.includes(query);

        modelItems.forEach((item) => {
          const itemText = item.dataset.searchText || '';
          const matches = query === '' || itemText.includes(query);
          item.classList.toggle('is-hidden', !matches);
          if (matches) groupHasMatch = true;
        });

        group.classList.toggle('is-hidden', !groupHasMatch);
        if (groupHasMatch) visibleGroups += 1;
      });

      if (this.emptyState) {
        this.emptyState.hidden = visibleGroups > 0 || query === '';
      }

      this.updateResultCount(visibleGroups, query);
    }

    updateResultCount(visibleGroups, query) {
      if (!this.resultCount) return;

      if (query === '' || query === undefined) {
        this.resultCount.textContent = '';
        return;
      }

      const count = visibleGroups ?? this.groups.filter((group) => !group.classList.contains('is-hidden')).length;
      const template = count === 1 ? this.root.dataset.resultsOne : this.root.dataset.resultsOther;
      this.resultCount.textContent = template.replace('{{ count }}', count);
    }
  }

  document.querySelectorAll('.vehicle-menu-index').forEach((root) => {
    new VehicleMenuIndex(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.vehicle-menu-index');
    if (root) new VehicleMenuIndex(root);
  });

  } catch(e) { console.error(e); }
})();
})();
